import { render, staticRenderFns } from "./Mt5AllTabs.vue?vue&type=template&id=6ff8ba9f"
import script from "./Mt5AllTabs.vue?vue&type=script&lang=js"
export * from "./Mt5AllTabs.vue?vue&type=script&lang=js"
import style0 from "./Mt5AllTabs.vue?vue&type=style&index=0&id=6ff8ba9f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports